// extracted by mini-css-extract-plugin
module.exports = {"reviewList":"ImageReviewList_reviewList__2Uq07","jumpToTopButton":"ImageReviewList_jumpToTopButton__18EeS"};